import { Box, Collapse } from '@mui/material';
import logo from './icons/logo.svg';

export const LogoExpandable = ({
  open,
  onClick,
}: {
  open: boolean;
  onClick: () => void;
}) => {
  return (
    <Collapse
      in={open}
      orientation='horizontal'
      collapsedSize={20}
      sx={{
        height: '34px',
        minHeight: '34px',
        margin: '8px 0',
      }}
    >
      <Box
        sx={{
          height: '34px',
          minWidth: '20px',
          width: 'auto',
          objectFit: 'cover',
          objectPosition: 'left center',
          padding: '0px 3px',
          cursor: 'pointer',
        }}
        component={'img'}
        src={logo}
        onClick={onClick}
      />
    </Collapse>
  );
};
